var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "salary-statistics"
  }, [_c('a-card', {
    staticClass: "filter-card",
    attrs: {
      "bordered": false
    }
  }, [_c('a-form-model', {
    attrs: {
      "model": _vm.queryForm,
      "layout": "vertical"
    }
  }, [_c('a-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "统计时间范围"
    }
  }, [_c('a-range-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": ['开始月份', '结束月份'],
      "format": "YYYY-MM",
      "mode": ['month', 'month']
    },
    on: {
      "panelChange": _vm.handlePanelChange
    },
    model: {
      value: _vm.queryForm.dateRange,
      callback: function callback($$v) {
        _vm.$set(_vm.queryForm, "dateRange", $$v);
      },
      expression: "queryForm.dateRange"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "统计类型"
    }
  }, [_c('a-radio-group', {
    attrs: {
      "button-style": "solid"
    },
    model: {
      value: _vm.queryForm.type,
      callback: function callback($$v) {
        _vm.$set(_vm.queryForm, "type", $$v);
      },
      expression: "queryForm.type"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("教职工")]), _c('a-radio', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("工勤人员")])], 1)], 1)], 1)], 1), _c('a-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "学部"
    }
  }, [_c('a-select', {
    attrs: {
      "mode": "multiple",
      "placeholder": "全部学部"
    },
    model: {
      value: _vm.queryForm.depts,
      callback: function callback($$v) {
        _vm.$set(_vm.queryForm, "depts", $$v);
      },
      expression: "queryForm.depts"
    }
  }, _vm._l(_vm.deptOptions, function (dept) {
    return _c('a-select-option', {
      key: dept,
      attrs: {
        "value": dept
      }
    }, [_vm._v(" " + _vm._s(dept) + " ")]);
  }), 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "统计字段"
    }
  }, [_c('a-select', {
    attrs: {
      "mode": "multiple",
      "placeholder": "全部薪酬项"
    },
    model: {
      value: _vm.queryForm.fields,
      callback: function callback($$v) {
        _vm.$set(_vm.queryForm, "fields", $$v);
      },
      expression: "queryForm.fields"
    }
  }, _vm._l(_vm.fieldOptions, function (field) {
    return _c('a-select-option', {
      key: field.value,
      attrs: {
        "value": field.value
      }
    }, [_vm._v(" " + _vm._s(field.label) + " ")]);
  }), 1)], 1)], 1)], 1), _c('div', {
    staticClass: "filter-actions"
  }, [_c('a-button', {
    attrs: {
      "icon": "reload"
    },
    on: {
      "click": _vm.resetQuery
    }
  }, [_vm._v("重置条件")]), _c('a-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary",
      "icon": "bar-chart"
    },
    on: {
      "click": _vm.generateReport
    }
  }, [_vm._v("生成统计报表")])], 1)], 1)], 1), _vm.showReport ? _c('div', {
    staticClass: "report-container"
  }, [_c('div', {
    staticClass: "report-actions"
  }, [_c('a-button', {
    attrs: {
      "type": "primary",
      "icon": "download"
    },
    on: {
      "click": _vm.exportReport
    }
  }, [_vm._v("导出报表")])], 1), _c('a-table', {
    staticClass: "statistics-table",
    attrs: {
      "columns": _vm.columns,
      "data-source": _vm.reportData,
      "loading": _vm.loading,
      "pagination": false,
      "row-key": "id",
      "bordered": "",
      "size": "middle",
      "row-class-name": _vm.getRowClassName,
      "scroll": {
        x: 'max-content'
      }
    }
  })], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };